var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vip_application_success_outer"}},[_c('div',[_vm._v("恭喜您已成为上海市篮球协会会员")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.timeValue)+"s后将自动跳转至"),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoVipeDetailPage}},[_vm._v("会员专属页")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f310e9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/personal/personApplicationVues/VipApplicationSuccess.vue
// module id = null
// module chunks = 